export const MANAGER_KPI_DATA = {
  manager1: {
    managerName: 'John Smith',
    metrics: [
      { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', section: 'General', unit: '$', isHigherBetter: true, goal: 500000, actuals: { weekly: 121000, monthly: 511667, quarterly: 1535000, yearly: 6140000 } },

      { key: 'customerSatisfaction', label: 'Customer Advocacy Score', category: 'Customer', section: 'General', unit: '%', isHigherBetter: true, goal: 90, actuals: { weekly: 89, monthly: 88.3, quarterly: 88.3, yearly: 88.1 } },
      { key: 'qualityScore', label: 'Quality Completion Rate', category: 'Customer', section: 'General', unit: 'pts', isHigherBetter: true, goal: 85, actuals: { weekly: 84, monthly: 83.5, quarterly: 83.5, yearly: 83.2 } },

      { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 85, actuals: { weekly: 87, monthly: 86.5, quarterly: 86.5, yearly: 86.2 } },
      { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', section: 'General', unit: 'min', isHigherBetter: false, goal: 10, actuals: { weekly: 9.4, monthly: 9.7, quarterly: 9.7, yearly: 9.8 } },
      { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 95, actuals: { weekly: 96, monthly: 95.8, quarterly: 95.8, yearly: 95.5 } },
      { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 88, actuals: { weekly: 90, monthly: 89.5, quarterly: 89.5, yearly: 89.2 } },

      { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', section: 'General', unit: '%', isHigherBetter: true, goal: 90, actuals: { weekly: 92, monthly: 91.4, quarterly: 91.4, yearly: 91 } }
    ]
  },
  manager2: {
    managerName: 'Sarah Johnson',
    metrics: [
      { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', section: 'General', unit: '$', isHigherBetter: true, goal: 480000, actuals: { weekly: 119200, monthly: 498333, quarterly: 1495000, yearly: 5980000 } },

      { key: 'customerSatisfaction', label: 'Customer Advocacy Score', category: 'Customer', section: 'General', unit: '%', isHigherBetter: true, goal: 88, actuals: { weekly: 87.2, monthly: 87.5, quarterly: 87.5, yearly: 87.2 } },
      { key: 'qualityScore', label: 'Quality Completion Rate', category: 'Customer', section: 'General', unit: 'pts', isHigherBetter: true, goal: 85, actuals: { weekly: 86.2, monthly: 86.2, quarterly: 86.2, yearly: 86 } },

      { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 82, actuals: { weekly: 82, monthly: 82.5, quarterly: 82.5, yearly: 82.8 } },
      { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', section: 'General', unit: 'min', isHigherBetter: false, goal: 11, actuals: { weekly: 11, monthly: 10.8, quarterly: 10.8, yearly: 10.9 } },
      { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 95, actuals: { weekly: 94.4, monthly: 94.4, quarterly: 94.4, yearly: 94.4 } },
      { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 85, actuals: { weekly: 86, monthly: 86, quarterly: 86, yearly: 86 } },

      { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', section: 'General', unit: '%', isHigherBetter: true, goal: 90, actuals: { weekly: 90.4, monthly: 90.4, quarterly: 90.4, yearly: 90.4 } }
    ]
  },
  manager3: {
    managerName: 'Mike Davis',
    metrics: [
      { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', section: 'General', unit: '$', isHigherBetter: true, goal: 420000, actuals: { weekly: 100000, monthly: 405000, quarterly: 1215000, yearly: 4860000 } },

      { key: 'customerSatisfaction', label: 'Customer Advocacy Score', category: 'Customer', section: 'General', unit: '%', isHigherBetter: true, goal: 85, actuals: { weekly: 83.8, monthly: 84, quarterly: 84, yearly: 83.5 } },
      { key: 'qualityScore', label: 'Quality Completion Rate', category: 'Customer', section: 'General', unit: 'pts', isHigherBetter: true, goal: 82, actuals: { weekly: 80, monthly: 80.4, quarterly: 80.4, yearly: 80.2 } },

      { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 78, actuals: { weekly: 77.4, monthly: 78.2, quarterly: 78.2, yearly: 77.8 } },
      { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', section: 'General', unit: 'min', isHigherBetter: false, goal: 13, actuals: { weekly: 13, monthly: 12.9, quarterly: 12.9, yearly: 13 } },
      { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 92, actuals: { weekly: 92, monthly: 92.2, quarterly: 92.2, yearly: 92 } },
      { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 82, actuals: { weekly: 81.4, monthly: 81.4, quarterly: 81.4, yearly: 81.4 } },

      { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', section: 'General', unit: '%', isHigherBetter: true, goal: 88, actuals: { weekly: 87.4, monthly: 87.4, quarterly: 87.4, yearly: 87.4 } }
    ]
  },
  manager4: {
    managerName: 'Lisa Chen',
    metrics: [
      { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', section: 'General', unit: '$', isHigherBetter: true, goal: 400000, actuals: { weekly: 101000, monthly: 409333, quarterly: 1228000, yearly: 4910000 } },

      { key: 'customerSatisfaction', label: 'Customer Advocacy Score', category: 'Customer', section: 'General', unit: '%', isHigherBetter: true, goal: 85, actuals: { weekly: 84.4, monthly: 84.7, quarterly: 84.7, yearly: 84.8 } },
      { key: 'qualityScore', label: 'Quality Completion Rate', category: 'Customer', section: 'General', unit: 'pts', isHigherBetter: true, goal: 80, actuals: { weekly: 79.6, monthly: 79.7, quarterly: 79.7, yearly: 79.8 } },

      { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 80, actuals: { weekly: 80, monthly: 80.5, quarterly: 80.5, yearly: 80.6 } },
      { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', section: 'General', unit: 'min', isHigherBetter: false, goal: 12, actuals: { weekly: 12, monthly: 11.8, quarterly: 11.8, yearly: 11.9 } },
      { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 93, actuals: { weekly: 93, monthly: 93, quarterly: 93, yearly: 93 } },
      { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 83, actuals: { weekly: 83, monthly: 83, quarterly: 83, yearly: 83 } },

      { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', section: 'General', unit: '%', isHigherBetter: true, goal: 90, actuals: { weekly: 90, monthly: 90, quarterly: 90, yearly: 90 } }
    ]
  },
  manager5: {
    managerName: 'Tom Martinez',
    metrics: [
      { key: 'revenuePerformance', label: 'Revenue Performance', category: 'Financial', section: 'General', unit: '$', isHigherBetter: true, goal: 350000, actuals: { weekly: 87800, monthly: 352333, quarterly: 1057000, yearly: 4228000 } },

      { key: 'customerSatisfaction', label: 'Customer Advocacy Score', category: 'Customer', section: 'General', unit: '%', isHigherBetter: true, goal: 82, actuals: { weekly: 81.4, monthly: 81.7, quarterly: 81.7, yearly: 81.8 } },
      { key: 'qualityScore', label: 'Quality Completion Rate', category: 'Customer', section: 'General', unit: 'pts', isHigherBetter: true, goal: 78, actuals: { weekly: 77.6, monthly: 77.7, quarterly: 77.7, yearly: 77.8 } },

      { key: 'laborEfficiency', label: 'Labor Efficiency', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 75, actuals: { weekly: 75, monthly: 75.7, quarterly: 75.7, yearly: 75.8 } },
      { key: 'serviceResponseTime', label: 'Service Response Time', category: 'Operational', section: 'General', unit: 'min', isHigherBetter: false, goal: 14, actuals: { weekly: 14, monthly: 13.7, quarterly: 13.7, yearly: 13.8 } },
      { key: 'attendanceReliability', label: 'Attendance Reliability', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 90, actuals: { weekly: 90, monthly: 90, quarterly: 90, yearly: 90 } },
      { key: 'teamProductivity', label: 'Team Productivity', category: 'Operational', section: 'General', unit: '%', isHigherBetter: true, goal: 80, actuals: { weekly: 80, monthly: 80, quarterly: 80, yearly: 80 } },

      { key: 'goalCompletionRate', label: 'Goal Completion Rate', category: 'Leadership', section: 'General', unit: '%', isHigherBetter: true, goal: 88, actuals: { weekly: 88, monthly: 88, quarterly: 88, yearly: 88 } }
    ]
  }
};

const STORAGE_KEY = 'manager-kpi-data-store';

const CATEGORY_ORDER = ['Financial', 'Customer', 'Operational', 'Leadership'];

function groupMetrics(metrics, period) {
  return CATEGORY_ORDER.map(category => {
    const categoryMetrics = metrics
      .filter(metric => metric.category === category)
      .map(metric => ({
        ...metric,
        actual: metric.actuals?.[period] ?? metric.actuals?.weekly ?? 0
      }));

    const sectionMap = categoryMetrics.reduce((sections, metric) => {
      const section = metric.section || 'General';
      if (!sections[section]) {
        sections[section] = [];
      }

      sections[section].push(metric);
      return sections;
    }, {});

    return {
      category,
      groups: Object.entries(sectionMap).map(([name, items]) => ({
        name,
        items
      }))
    };
  }).filter(category => category.groups.length > 0);
}

function cloneSeedData() {
  return JSON.parse(JSON.stringify(MANAGER_KPI_DATA));
}

export function getManagerKpiDataStore() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return cloneSeedData();
  }

  const storedValue = window.localStorage.getItem(STORAGE_KEY);
  if (!storedValue) {
    const seeded = cloneSeedData();
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seeded));
    return seeded;
  }

  try {
    return JSON.parse(storedValue);
  } catch (error) {
    const seeded = cloneSeedData();
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(seeded));
    return seeded;
  }
}

export function saveManagerKpiDataStore(data) {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getKpiManagerOptions() {
  const data = getManagerKpiDataStore();

  return Object.entries(data).map(([id, manager]) => ({
    id,
    name: manager.managerName
  }));
}

export function updateKpiMetricValues({ managerId, metricKey, goal, dailyActual, period, date }) {
  const data = getManagerKpiDataStore();
  const manager = data[managerId];

  if (!manager) {
    return false;
  }

  const metric = manager.metrics.find(item => item.key === metricKey);
  if (!metric) {
    return false;
  }

  const nextGoal = Number(goal);
  const nextActual = Number(dailyActual);
  const safeDate = date || new Date().toISOString().slice(0, 10);
  const targetPeriod = period || 'weekly';

  if (!Number.isNaN(nextGoal)) {
    metric.goal = nextGoal;
  }

  if (!Number.isNaN(nextActual)) {
    metric.actuals = {
      ...metric.actuals,
      [targetPeriod]: nextActual
    };
    metric.dailyActuals = {
      ...(metric.dailyActuals || {}),
      [safeDate]: nextActual
    };
  }

  saveManagerKpiDataStore(data);
  return true;
}

export function addKpiMetric({ managerId, metric }) {
  const data = getManagerKpiDataStore();
  const manager = data[managerId];

  if (!manager) {
    return false;
  }

  const newMetric = {
    ...metric,
    goal: Number(metric.goal) || 0,
    actuals: {
      weekly: Number(metric.actuals?.weekly) || 0,
      monthly: Number(metric.actuals?.monthly) || 0,
      quarterly: Number(metric.actuals?.quarterly) || 0,
      yearly: Number(metric.actuals?.yearly) || 0
    }
  };

  if (manager.metrics.some(item => item.key === newMetric.key)) {
    return false;
  }

  manager.metrics.push(newMetric);
  saveManagerKpiDataStore(data);
  return true;
}

export function addKpiManager({ managerId, managerName }) {
  const data = getManagerKpiDataStore();

  if (!managerId || data[managerId]) {
    return false;
  }

  data[managerId] = {
    managerName,
    metrics: []
  };

  saveManagerKpiDataStore(data);
  return true;
}

export function createKpiOnlyManagerRecord(managerId) {
  const data = getManagerKpiDataStore();
  const manager = data[managerId];

  if (!manager) {
    return null;
  }

  const kpisByPeriod = ['weekly', 'monthly', 'quarterly', 'yearly'].reduce((periodMap, period) => {
    periodMap[period] = manager.metrics.reduce((metrics, metric) => {
      metrics[metric.key] = {
        '1': metric.actuals?.[period] ?? 0
      };
      return metrics;
    }, {});

    return periodMap;
  }, {});

  const goalMap = manager.metrics.reduce((targets, metric) => {
    targets[metric.key] = metric.goal;
    return targets;
  }, {});

  const unitMap = manager.metrics.reduce((units, metric) => {
    units[metric.key] = metric.unit;
    return units;
  }, {});

  return {
    id: managerId,
    name: manager.managerName,
    role: 'Manager',
    position: 'Manager',
    department: 'Live Scorecard',
    notes: 'Built from fallback KPI data.',
    goalMap,
    unitMap,
    kpis: kpisByPeriod,
    attendance: [],
    vacations: []
  };
}

export function getManagerKpiDashboardData(managerId, period) {
  const managerData = getManagerKpiDataStore()[managerId];

  if (!managerData) {
    return null;
  }

  return {
    managerName: managerData.managerName,
    totalMetrics: managerData.metrics.length,
    categories: groupMetrics(managerData.metrics, period)
  };
}
